import React from 'react';

const TickIcon = (props) => (
  <svg {...props} viewBox='0 0 11 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.0001 1L4.00004 7.00002L1 4'
      stroke={props.fill}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default TickIcon;
